<template>
    <div :class="['response', `response-${response.correct ? 'correct' : 'incorrect'}`]">
        <i :class="[`fa`, `fa-${response.correct ? 'circle-check' : 'circle-xmark'}`]"></i>
        <p class="response-name">{{ response.name }}:</p>
        <p class="response-response">{{ response.response }}</p>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
    response: Object
});

</script>

<style lang="scss">
@import '@/styles/variables.scss';

.response {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    &-correct,
    &-correct p {
        color: $green !important;
    }

    &-incorrect,
    &-incorrect p {
        color: $red !important;
    }

    i {
        width: 1rem;
        text-align: right;
        flex-shrink: 0;
    }

    p {
        margin: 0;
    }

    &-name{
        font-weight: bold;
    }

    &-response {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>